/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { IWizardOrderReportReducer } from './reducer';

 export enum EWizardOrderReportSteps {
     ReportSelectionDataStep = 'ReportSelectionDataStep',
     ReportSelectionParametersStep = 'ReportSelectionParametersStep',
     ReportConfirmStep = 'ReportConfirmStep',
 }

 export const initWizardOrderReportState: IWizardOrderReportReducer = {
     validation: {
         isValid: true,
         error: '',
     },
 };

 /*
  * -------------------------------------------
  *           Common Wizard Actions
  * -------------------------------------------
  */

 export const WIZARD_ORDER_REPORT_HANDLE_NEXT =
     '@@b2b_portal_ui/wizardOrderReport/WIZARD_ORDER_REPORT_HANDLE_NEXT';

 export const WIZARD_ORDER_REPORT_SET_STEP_VALID =
     '@@b2b_portal_ui/wizardOrderReport/WIZARD_ORDER_REPORT_SET_STEP_VALID';

 export const WIZARD_ORDER_REPORT_SET_PARAMS =
     '@@b2b_portal_ui/wizardOrderReport/WIZARD_ORDER_REPORT_SET_PARAMS';
